import { useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { FaEdit, FaTrashAlt } from 'react-icons/fa'
import { useSelector } from 'react-redux'

import { useGetCategoriesPaginatedQuery } from '../../../api/services/categoriesApi'
import { CreateCategoriesModal, DeleteCategoryModal, UpdateCompanyCategory } from '../../modals/modals'
import { Button } from '../../root/Button'
import NewTable from '../NewTable'

const TableCompanyCategories = () => {
  const { t } = useTranslation()

  const [page, setPage] = useState(1)
  const [pageSize, setPageSize] = useState(25)
  const [filterInputs, setFilterInputs] = useState({})

  const columns = useMemo(
    () => [
      {
        Header: t('name'),
        accessor: 'categoryName',
      },
      {
        Header: t('desc'),
        accessor: 'categoryDescription',
      },
    ],
    [t],
  )

  const [openCreate, setOpenCreate] = useState(false)
  const [openUpdate, setOpenUpdate] = useState(false)
  const [openDelete, setOpenDelete] = useState(false)
  const [category, setCategory] = useState()

  const [approval, setApproval] = useState(false)

  const company = useSelector((state) => state.company.company)

  const query = useMemo(() => {
    let queryString = ''
    for (const [key, value] of Object.entries(filterInputs)) {
      if (value.trim() !== '') {
        queryString += `${key}=${encodeURIComponent(value)}&`
      }
    }

    return queryString.replace(/&$/, '')
  }, [filterInputs])

  const { data: paginatedCategories, isFetching, isLoading } = useGetCategoriesPaginatedQuery(
    {
      companyId: company?.id,
      page,
      pageSize,
      query: query || '',
    },
    { skip: !company?.id },
  )

  const data = useMemo(
    () => (Array.isArray(paginatedCategories?.categories) ? paginatedCategories.categories : []),
    [paginatedCategories],
  )

  const handleClose = () => {
    setOpenCreate(!openCreate)
  }

  const tableHooksArray = [
    {
      label: t('edit'),
      Icon: FaEdit,
      onClick: (row) => {
        setCategory(row.original)
        if (row.original.requiredApproval === 1) {
          setApproval(true)
        } else {
          setApproval(false)
        }
        setOpenUpdate(true)
      },
      disabled: false,
    },
    {
      label: t('delete'),
      Icon: FaTrashAlt,
      onClick: (row) => {
        setCategory(row.original)
        setOpenDelete(true)
      },
      disabled: false,
    },
  ]

  return (
    <div className="wrapper phone:hidden mt-2 flex flex-col gap-4">
      <div className="w-full flex justify-start">
        <div className="w-full max-w-xs">
          <Button onClick={() => setOpenCreate(true)}>{t('create_cat')}</Button>
        </div>
      </div>

      <NewTable
        data={data}
        columns={columns}
        actions
        filtering
        hooksArray={tableHooksArray}
        hiddenColumns={['address']}
        setPage={setPage}
        pageManual={page}
        pageSize={pageSize}
        setPageAmount={setPageSize}
        controlledPageCount={paginatedCategories?.totalPages || 0}
        filterInputs={filterInputs}
        setFilterInputs={setFilterInputs}
        count={paginatedCategories?.totalCount}
        isFetching={isFetching}
        isLoading={isLoading}
      />

      <DeleteCategoryModal onClose={() => setOpenDelete(false)} category={category} open={openDelete} />
      <UpdateCompanyCategory
        onClose={() => setOpenUpdate(false)}
        approval={approval}
        category={category}
        open={openUpdate}
      />
      <CreateCategoriesModal open={openCreate} close={handleClose} />
    </div>
  )
}
export default TableCompanyCategories
